import React, { useState, useEffect } from 'react';
import { Modal, Form, Row, Col, Button, InputGroup } from 'react-bootstrap';
import Select from 'react-select';
import AlertsFacturas from '../../facturas/Utils/AlertsFacturas';
import APIserver from '../../../../api/axiosConfig';

const CrearPagoResModal = ({ show, handleClose, factura, bancos, onSuccess }) => {
  const [currectDate, setCurrentDate] = useState('');
  const numFacturaInicial = factura?.numeroFactura || factura?.numFacV || '';
  const [preferredBankId, setPreferredBankId] = useState(() => {
    try {
      return localStorage.getItem('banco_preferido_pago') || '';
    } catch (e) {
      return '';
    }
  });

  const [preferredTipoPago, setPreferredTipoPago] = useState(() => {
    try {
      return localStorage.getItem('tipo_pago_preferido_res') || '';
    } catch (e) {
      return '';
    }
  });

  const [formData, setFormData] = useState({
    numeroFactura: numFacturaInicial,
    nombreCliente: factura?.clienteNombre || '',
    tipoPago: (() => {
      try {
        return localStorage.getItem('tipo_pago_preferido_res') || '';
      } catch (e) {
        return '';
      }
    })(),
    banco: null,
    monto: '',
    observaciones: ''
  });
  const [montoMaximo, setMontoMaximo] = useState(0);
  const [idFactura, setIdFactura] = useState(null); // Estado para guardar el ID de la factura
  const [bankOptions, setBankOptions] = useState([]); // Estado para guardar las opciones de banco
  const [errors, setErrors] = useState({}); // Estado para errores de validación
  const [isSaving, setIsSaving] = useState(false);
  const [allBanksRaw, setAllBanksRaw] = useState([]);

  const optionsPago = [
    { value: 'transferencia', label: 'Transferencias' },
    { value: 'efectivo', label: 'Efectivo' }
  ];

  const ordenarOpciones = (lista, idPref) => {
    if (!lista || lista.length === 0) return [];
    if (!idPref) return [...lista];

    const preferidos = [];
    const otros = [];

    lista.forEach(b => {
      if (String(b.value) === String(idPref)) {
        preferidos.push(b);
      } else {
        otros.push(b);
      }
    });

    return [...preferidos, ...otros];
  };

  const cargarBancos = async (idPref = preferredBankId) => {
    try {
      const prefId = idPref || localStorage.getItem('banco_preferido_pago') || '';
      const response = await APIserver.get(`/api/pagosrecibidos/mostrar/bancos`);
      const banks = response.data.bancos || [];
      const mapped = banks.map(banco => ({
        value: banco.idBanco,
        label: banco.nomBanco
      }));
      setAllBanksRaw(mapped);
      setBankOptions(ordenarOpciones(mapped, prefId));

      // Preseleccionar el banco preferido por defecto si existe
      if (prefId) {
        const bancoFav = mapped.find(b => String(b.value) === String(prefId));
        if (bancoFav) {
          setFormData(prev => ({
            ...prev,
            banco: prev.banco || bancoFav
          }));
        }
      }
    } catch (error) {
      console.error('Error al obtener bancos:', error);
      AlertsFacturas.showErrorMessage('Error al obtener bancos.');
    }
  };

  const handleTogglePreferred = (idBanco) => {
    let nuevoPreferido = '';
    if (String(preferredBankId) === String(idBanco)) {
      nuevoPreferido = '';
      try {
        localStorage.removeItem('banco_preferido_pago');
      } catch (e) {}
    } else {
      nuevoPreferido = String(idBanco);
      try {
        localStorage.setItem('banco_preferido_pago', String(idBanco));
      } catch (e) {}
      // Seleccionar automáticamente al marcar
      const favOption = allBanksRaw.find(b => String(b.value) === String(idBanco));
      if (favOption) {
        setFormData(prev => ({ ...prev, banco: favOption }));
      }
    }
    setPreferredBankId(nuevoPreferido);
    setBankOptions(ordenarOpciones(allBanksRaw, nuevoPreferido));
  };

  const handleTogglePreferredTipoPago = (val) => {
    let nuevoPreferido = '';
    if (String(preferredTipoPago) === String(val)) {
      nuevoPreferido = '';
      try {
        localStorage.removeItem('tipo_pago_preferido_res');
      } catch (e) {}
    } else {
      nuevoPreferido = String(val);
      try {
        localStorage.setItem('tipo_pago_preferido_res', String(val));
      } catch (e) {}
      // Seleccionar automáticamente al marcar
      setFormData(prev => ({ ...prev, tipoPago: val }));
    }
    setPreferredTipoPago(nuevoPreferido);
  };

  const CustomOption = (props) => {
    const { data, isSelected, isFocused, innerRef, innerProps } = props;
    const isChecked = String(data.value) === String(preferredBankId);

    const handleCheckboxClick = (e) => {
      e.stopPropagation();
      e.preventDefault();
      handleTogglePreferred(data.value);
    };

    return (
      <div
        ref={innerRef}
        {...innerProps}
        className="d-flex justify-content-between align-items-center px-3 py-2"
        style={{
          backgroundColor: isSelected
            ? '#2c4cc4'
            : isFocused
            ? '#eef2ff'
            : '#ffffff',
          color: isSelected ? '#ffffff' : '#212529',
          cursor: 'pointer',
          borderBottom: '1px solid #f1f3f5'
        }}
      >
        <span className="flex-grow-1 text-truncate pe-2">{data.label}</span>
        <div
          onClick={handleCheckboxClick}
          title={isChecked ? 'Quitar de preferido' : 'Chulear para que salga de primero y predefinido'}
          className="d-flex align-items-center ps-2"
          style={{ cursor: 'pointer' }}
        >
          <input
            type="checkbox"
            className="form-check-input m-0"
            checked={isChecked}
            onChange={handleCheckboxClick}
            style={{
              cursor: 'pointer',
              width: '18px',
              height: '18px',
              accentColor: '#2c4cc4'
            }}
          />
        </div>
      </div>
    );
  };

  const CustomOptionTipoPago = (props) => {
    const { data, isSelected, isFocused, innerRef, innerProps } = props;
    const isChecked = String(data.value) === String(preferredTipoPago);

    const handleCheckboxClick = (e) => {
      e.stopPropagation();
      e.preventDefault();
      handleTogglePreferredTipoPago(data.value);
    };

    return (
      <div
        ref={innerRef}
        {...innerProps}
        className="d-flex justify-content-between align-items-center px-3 py-2"
        style={{
          backgroundColor: isSelected
            ? '#2c4cc4'
            : isFocused
            ? '#eef2ff'
            : '#ffffff',
          color: isSelected ? '#ffffff' : '#212529',
          cursor: 'pointer',
          borderBottom: '1px solid #f1f3f5'
        }}
      >
        <span className="flex-grow-1 text-truncate pe-2">{data.label}</span>
        <div
          onClick={handleCheckboxClick}
          title={isChecked ? 'Quitar de preferido' : 'Chulear para que salga de primero y predefinido'}
          className="d-flex align-items-center ps-2"
          style={{ cursor: 'pointer' }}
        >
          <input
            type="checkbox"
            className="form-check-input m-0"
            checked={isChecked}
            onChange={handleCheckboxClick}
            style={{
              cursor: 'pointer',
              width: '18px',
              height: '18px',
              accentColor: '#2c4cc4'
            }}
          />
        </div>
      </div>
    );
  };

  // Este useEffect se ejecuta al abrir el modal o al cambiar la prop `factura`
  useEffect(() => {
    const numFactura = factura?.numeroFactura || factura?.numFacV || '';
    const currentPrefBank = localStorage.getItem('banco_preferido_pago') || '';
    const currentPrefTipo = localStorage.getItem('tipo_pago_preferido_res') || '';

    setPreferredBankId(currentPrefBank);
    setPreferredTipoPago(currentPrefTipo);

    if (numFactura.trim() !== '') {
      let defaultBanco = null;
      if (currentPrefBank && allBanksRaw.length > 0) {
        defaultBanco = allBanksRaw.find(b => String(b.value) === String(currentPrefBank)) || null;
      }

      // Asignar los valores iniciales de la factura al formulario
      setFormData(prev => ({
        ...prev,
        numeroFactura: numFactura,
        nombreCliente: factura?.clienteNombre || prev.nombreCliente || '',
        tipoPago: currentPrefTipo || prev.tipoPago || '',
        banco: defaultBanco || prev.banco
      }));

      // Actualizar el ID de la factura y calcular el monto máximo permitido
      const obtenerDatosClienteYFactura = async () => {
        try {
          const response = await APIserver.get(`/api/pagosrecibidos/nombreCliente/${numFactura}`);
          const { nombreCliente, idFactura, totalFacV, pagadoFacV } = response.data;

          if (totalFacV === undefined || pagadoFacV === undefined) {
            console.error('Datos de factura incompletos:', response.data);
            AlertsFacturas.showErrorMessage('Datos de factura incompletos.');
            return;
          }

          // Actualizar el estado del formulario con los datos obtenidos
          setFormData(prevFormData => ({
            ...prevFormData,
            nombreCliente: nombreCliente,
            numeroFactura: numFactura
          }));
          setIdFactura(idFactura);

          // Calcular el monto máximo permitido
          const calculadoMontoMaximo = totalFacV - pagadoFacV;
          setMontoMaximo(calculadoMontoMaximo);
        } catch (error) {
          console.error('Error al buscar la factura:', error);
          AlertsFacturas.showErrorMessage('Factura no encontrada.');
        }
      };

      obtenerDatosClienteYFactura();
      cargarBancos();
    }
  }, [factura, show]);  // Ejecuta este efecto cuando la prop `factura` cambia

  useEffect(() => {
    if (show) {
      const curPrefBank = localStorage.getItem('banco_preferido_pago') || '';
      const curPrefTipo = localStorage.getItem('tipo_pago_preferido_res') || '';
      setPreferredBankId(curPrefBank);
      setPreferredTipoPago(curPrefTipo);

      setFormData(prev => {
        const updated = { ...prev };
        if (curPrefTipo) {
          updated.tipoPago = curPrefTipo;
        }
        if (curPrefBank && allBanksRaw.length > 0) {
          const found = allBanksRaw.find(b => String(b.value) === String(curPrefBank));
          if (found) {
            updated.banco = found;
          }
        }
        return updated;
      });
    }
  }, [show, allBanksRaw]);

  useEffect(() => {
    const today = new Date();
    const yyyy = today.getFullYear();
    const mm = String(today.getMonth() + 1).padStart(2, '0');
    const dd = String(today.getDate()).padStart(2, '0');
    setCurrentDate(`${yyyy}-${mm}-${dd}`);
  }, []);

  useEffect(() => {
    cargarBancos();
  }, []);

  // Cambiamos la función handleInputChange
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  // Nueva función para manejar la búsqueda al salir del input
  const handleFacturaBlur = async () => {
    const { numeroFactura } = formData;

    if (numeroFactura.trim() !== '') {
      try {
        const response = await APIserver.get(`/api/pagosrecibidos/nombreCliente/${numeroFactura}`);
        const { nombreCliente, idFactura, totalFacV, pagadoFacV } = response.data;

        if (totalFacV === undefined || pagadoFacV === undefined) {
          console.error('Datos de factura incompletos:', response.data);
          AlertsFacturas.showErrorMessage('Datos de factura incompletos.');
          return;
        }

        // Actualizar el estado con los datos obtenidos
        setFormData(prevFormData => ({
          ...prevFormData,
          nombreCliente: nombreCliente,
          numeroFactura: numeroFactura
        }));
        setIdFactura(idFactura);
        setMontoMaximo(totalFacV - pagadoFacV);
      } catch (error) {
        console.error('Error al buscar la factura:', error);
        AlertsFacturas.showErrorMessage('Factura no encontrada.');
      }
    }
  };

  const handleSelectChange = (selectedOption, { name }) => {
    setFormData({
      ...formData,
      [name]: selectedOption
    });
  };

  const handleDateChange = (e) => {
    setCurrentDate(e.target.value); // Actualizar la fecha seleccionada
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.numeroFactura.trim()) newErrors.numeroFactura = 'Este campo es obligatorio';
    if (!formData.nombreCliente.trim()) newErrors.nombreCliente = 'Este campo es obligatorio';
    if (!formData.tipoPago) newErrors.tipoPago = 'Seleccione un tipo de pago';
    if (!formData.banco) newErrors.banco = 'Seleccione un banco';
    if (!currectDate) newErrors.fecha = 'Seleccione una fecha';
    if (!formData.monto || parseFloat(formData.monto) <= 0) newErrors.monto = 'Ingrese un monto válido';
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSave = async () => {
    if (!validateForm() || isSaving) {
      return; // Evita múltiples clics
    }

    setIsSaving(true); // Deshabilitar el botón al iniciar la solicitud

    try {
      const monto = parseFloat(formData.monto.replace(/,/g, ''));
      const pendiente = montoMaximo - monto;

      await APIserver.post(`/api/pagosrecibidos/guardar/pagoF`, {
        fecha: currectDate,
        detalle: formData.observaciones,
        idBanco: formData.banco ? formData.banco.value : null,
        monto: monto,
        pendiente: pendiente,
        idFacV: idFactura
      });

      await APIserver.put(`/api/actualizar/factura`, {
        idFactura: idFactura,
        pagadoFacV: monto,
        pendienteFacV: pendiente,
        numeroFactura: formData.numeroFactura
      });

      handleClose(true);
      AlertsFacturas.showPaymentSuccessMessage('Pago agregado exitosamente', () => {
        if (typeof onSuccess === 'function') {
          onSuccess();
        } else {
          window.location.reload();
        }
      });
    } catch (error) {
      console.error('Error al guardar el pago:', error);
      AlertsFacturas.showErrorMessage('Hubo un error al agregar el pago.');
    } finally {
      setIsSaving(false); // Reactivar el botón tras finalizar la solicitud
    }
  };


  return (
    <Modal size="lg" show={show} onHide={handleClose} aria-labelledby='create-pagoRes-modal'>
      <Modal.Header closeButton>
        <Modal.Title>Nuevo Pago Recibido</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Row>
            <Col xs={12} md={6}>
              <Form.Group className="m-3 mt-0" controlId="numPedido">
                <Form.Label>Numero de Factura</Form.Label>
                <Form.Control
                  type="text"
                  name="numeroFactura"
                  value={formData.numeroFactura}
                  onChange={handleInputChange}
                  onBlur={handleFacturaBlur}  // Ahora la búsqueda se ejecuta al perder el foco
                  placeholder="Número de factura"
                  isInvalid={!!errors.numeroFactura}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.numeroFactura}
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group className="m-3" controlId="nomCliente">
                <Form.Label>Cliente</Form.Label>
                <Form.Control
                  type="text"
                  name="nombreCliente"
                  value={formData.nombreCliente}
                  placeholder='Nombre del Cliente'
                  readOnly
                  isInvalid={!!errors.nombreCliente}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.nombreCliente}
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group className='m-3' controlId='tipoPago'>
                <Form.Label className='w-100'>Tipo</Form.Label>
                <Select
                  placeholder='Tipo de Pago'
                  name='tipoPago'
                  value={optionsPago.find(option => option.value === (formData.tipoPago?.value || formData.tipoPago)) || null}
                  onChange={(selectedOption) => {
                    setFormData(prev => ({
                      ...prev,
                      tipoPago: selectedOption ? selectedOption.value : ''
                    }));
                  }}
                  options={ordenarOpciones(optionsPago, preferredTipoPago)}
                  components={{ Option: CustomOptionTipoPago }}
                  isInvalid={!!errors.tipoPago}
                />
                {errors.tipoPago && <div className="invalid-feedback d-block">{errors.tipoPago}</div>}
              </Form.Group>
            </Col>
            <Col xs={12} md={6}>
              <Form.Group className="m-3 mt-0" controlId="fechaPago">
                <Form.Label>Fecha</Form.Label>
                <Form.Control
                  type="date"
                  value={currectDate}
                  onChange={handleDateChange}
                  isInvalid={!!errors.fecha}
                  required
                />
                <Form.Control.Feedback type="invalid">
                  {errors.fecha}
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group className="m-3" controlId="nomBanco">
                <Form.Label>Banco</Form.Label>
                <Select
                  placeholder='Seleccione el Banco'
                  name='banco'
                  value={formData.banco}
                  onChange={(selectedOption) => handleSelectChange(selectedOption, { name: 'banco' })}
                  options={bankOptions}
                  components={{ Option: CustomOption }}
                  isInvalid={!!errors.banco}
                />
                {errors.banco && <div className="invalid-feedback d-block">{errors.banco}</div>}
              </Form.Group>
              <Form.Group className="m-3" controlId="montoPago">
                <Form.Label>Monto</Form.Label>
                <InputGroup className="mb-3">
                  <InputGroup.Text>$</InputGroup.Text>
                  <Form.Control
                    type='number'
                    name='monto'
                    value={formData.monto}
                    onChange={handleInputChange}
                    placeholder='Pago total realizado'
                    isInvalid={!!errors.monto}
                    step="0.01"
                    required
                  />
                  <InputGroup.Text>.00</InputGroup.Text>
                  <Form.Control.Feedback type="invalid">
                    {errors.monto}
                  </Form.Control.Feedback>
                </InputGroup>
                <Form.Text className='text-muted'>
                  Saldo de factura: {montoMaximo.toLocaleString('es-CO', { style: 'currency', currency: 'COP', minimumFractionDigits: 0, maximumFractionDigits: 0 })}
                </Form.Text>
              </Form.Group>
            </Col>
          </Row>
          <Form.Group className="m-3 mt-0" controlId="detallePago">
            <Form.Label>Observaciones</Form.Label>
            <Form.Control
              as="textarea"
              name="observaciones"
              value={formData.observaciones}
              onChange={handleInputChange}
              placeholder="Observaciones sobre el pago (Opcional)"
            />
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="danger" onClick={handleClose}>Cancelar</Button>
        <Button variant="dark" onClick={handleSave} disabled={isSaving}>
          {isSaving ? 'Guardando...' : 'Guardar'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default CrearPagoResModal;
